import { createContext, useContext } from 'react';

import { IModuleContext } from './types';

const ModuleContext = createContext<IModuleContext>({} as IModuleContext);

export const useModuleContext = (): IModuleContext => useContext(ModuleContext);

export const ModuleProvider = ModuleContext.Provider;
